module.exports = __webpack_public_path__ + "img/termania.4fef52e8.svg";